import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { useCallback } from "react";
import { ModalLoading } from "../../../../../../common/components/modal_loading";
import FormContainer from "../../../../../../common/components/form_container";
import PrimaryButton from "../../../../../../common/components/primary_button";
import { DropDown } from "../../../../../../common/domain/models/dropdown";
import { DefaultMultiAutocomplete } from "../../../../../../common/components/default_multi_autocomplete";

/**
 * CadastroSaldoBancario
 */

type Props = {
    open: boolean,
    saving: boolean,
    ddlCentroCusto: DropDown[],
    selectedIdsCentroCusto: number[],

    handleIdCentroCustoChange: (ids: number[]) => void,
    onSubmit: () => void,
    onClose: () => void,

};

export const CadastroCentroCustoRateioModal = ({
    open,
    saving,
    ddlCentroCusto,
    selectedIdsCentroCusto,
    handleIdCentroCustoChange,
    onSubmit,
    onClose,

}: Props) => {

    const handleClose = useCallback(() => {
        if (!saving)
            onClose();
    }, [saving, onClose]);

    return (

        <Dialog
            open={open}
            slotProps={{
                paper: {
                    component: 'form',
                }
            }}
            sx={{
                "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "45rem",
                    },
                },
            }}>

            <DialogTitle>
                Incluir Centros de Custo no Rateio Geral
            </DialogTitle>

            <DialogContent>
                <ModalLoading loading={saving}>
                    <FormContainer title={"Informações"} arrangement="fullRow">
                        <div className="w-full bg-white p-4  rounded-2xl shadow-sm space-y-3">

                            <div className="w-full">
                                <DefaultMultiAutocomplete
                                    label='Centro de Custo'
                                    value={ddlCentroCusto.filter(x => selectedIdsCentroCusto?.includes(x.id))}
                                    options={ddlCentroCusto}
                                    getOptionLabel={x => x.title}
                                    getOptionKey={x => x.id}
                                    onChange={x => handleIdCentroCustoChange(x?.map(y => y.id) ?? [])} />
                            </div>

                        </div>
                    </FormContainer>
                </ModalLoading>
            </DialogContent>

            <DialogActions>
                <div className="w-full h-full items-end justify-end flex px-4 pb-4 gap-4">

                    <div className="flex flex-row gap-2">
                        <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                            <h1
                                className="text-sm text-black dark:text-white"
                                onClick={handleClose}>
                                Cancelar
                            </h1>
                        </div>

                        <div className="w-[120px]">
                            {saving ? (
                                <PrimaryButton
                                    onClick={() => onSubmit()}
                                    buttonColor="primary-green">
                                    Salvando...
                                </PrimaryButton>
                            ) : (
                                <PrimaryButton
                                    onClick={() => onSubmit()}
                                    buttonColor="primary-green">
                                    Incluir
                                </PrimaryButton>
                            )}
                        </div>
                    </div>
                </div>
            </DialogActions>
        </Dialog >
    );
}